import Button from "react-bootstrap/Button";
import { LuPencilLine } from "react-icons/lu";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { Formik } from "formik";
// import * as yup from "yup";
// import { ValidationCons } from "../validation/validationConstant";
import { showError, showSuccess } from "../utils/Common";
import { updateAccountDetails } from "../service/apis/auth.api";
import { setUser } from "../store/auth.store";
import { TagsInput } from "react-tag-input-component";
import { ResumeSkillSchema } from "../validation/validator";

const SkillDetailsScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.authSlice);

  const [showSkills, setShowSkills] = useState(false);
  const handleCloseSK = () => setShowSkills(false);
  const [skills, setSkills] = useState({ skills: [] });  

  const handleShowSK = () => {
    setSkills({ skills: user?.skill });
    setShowSkills(true);
  };


  // const skillProfileik = useFormik({
  //   initialValues: {
  //     skills: "",
  //   },
  //   validationSchema: yup.object({
  //     skill: yup.string().trim().required(ValidationCons.SKILL_REQUIRED),
  //   }),
  //   onSubmit: async (values: any) => {
  //     try {
  //       const skillsArray = values.skill
  //         .split(",")
  //         .map((skl: any) => skl.trim());

  //       let bodyData = {
  //         skill: skillsArray,
  //       };

  //       const response = await updateAccountDetails(bodyData);
  //       const successmessages = response?.message;

  //       if (successmessages) {
  //         if (successmessages !== "Profile Data") {
  //           showError(response && response.message);
  //         } else {
  //           handleCloseSK();
  //           dispatch(setUser(response.user));
  //           showSuccess("Skill Info Updated successfully");
  //         }
  //       }
  //     } catch (error) {
  //       //   setLoading(false);
  //       showError(error);
  //     }
  //   },
  // });

  useEffect(() => {
    if (user?.skill) {
      setSkills({ skills: user?.skill });
    }
    // console.log(user,558);
    
  }, [user]);

    const handleSubmit = async (values: any) => {
      // console.log(values,5584);
      // return;
      try {
        // const skillsArray = values.skill
        //   .split(",")
        //   .map((skl: any) => skl.trim());

        let bodyData = {
          skill: values.skills,
        };

        const response = await updateAccountDetails(bodyData);
        const successmessages = response?.message;

        if (successmessages) {
          if (successmessages !== "Profile Data") {
            showError(response && response.message);
          } else {
            handleCloseSK();
            dispatch(setUser(response.user));
            showSuccess("Skill Info Updated successfully");
          }
        }
      } catch (error) {
        //   setLoading(false);
        showError(error);
      }
    };
  return (
    <>
      <div className="comnbrdrGap profileEdit mb-4">
        <div className="d-flex">
          <h3>Skills</h3>
          <button className="editbtn" onClick={handleShowSK}>
            <LuPencilLine /> Edit
          </button>
        </div>
        <div className="ppsrch">
          <ul>
            {user?.skill &&
              user?.skill?.map((ski: string, index: number) => (
                <li key={index}>
                  <span>{ski}</span>
                </li>
              ))}
          </ul>
        </div>
      </div>
      <Modal
        show={showSkills}
        onHide={handleCloseSK}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editSkill"
        centered
      >
        <Modal.Body>
          <div className="findbody">
            <h3>Add Skills</h3>
            <Formik
                        initialValues={skills}
                        validationSchema={ResumeSkillSchema}
                        onSubmit={handleSubmit}
                      >
                        {({
                          setFieldValue,
                          values,
                          errors,
                          touched,
                          handleBlur,
                          handleSubmit,
                        }) => (
            <Form
              className="modalSearch"
              onSubmit={handleSubmit}
            >
              <Form.Group className="mb-3">
                <Form.Label>Skills {" "}
                    <span className="text-danger">
                      ( Press Enter after entering a value. )
                    </span></Form.Label>
                {/* <Form.Control
                  as="textarea"
                  placeholder="Prototyping , UI Design, Programming"
                  name="skill"
                  // onChange={skillProfileik.handleChange}
                  onBlur={skillProfileik.handleBlur}
                  value={
                    Array.isArray(skillProfileik.values.skill)
                      ? skillProfileik.values.skill.join(", ")
                      : skillProfileik.values.skill
                  }
                  isInvalid={
                    !!skillProfileik.errors.skill &&
                    Boolean(skillProfileik.touched.skill)
                  }
                /> */}
                <TagsInput
                  value={values.skills}
                  onChange={(newTags) => setFieldValue("skills", newTags)}
                  onBlur={handleBlur}
                  name="skills"
                  placeHolder="Enter skill"
                />

                  {/* {touched.skills && errors.skills && (
                    <div className="text-danger mt-2">{errors.skills}</div>
                  )} */}

                <Form.Control.Feedback type="invalid">
                  {typeof errors.skills === "string" &&
                    errors.skills}
                </Form.Control.Feedback>
              </Form.Group>
              <div className="d-flex gp-10">
                {/* <Button className="btn btn-black w-100" type="button">Add More</Button> */}
                <Button className="btn w-100" type="submit">
                  Save
                </Button>
              </div>
            </Form>
            )}
            </Formik>
            
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default SkillDetailsScreen;
